import { render, staticRenderFns } from "./ViewDashboards.vue?vue&type=template&id=371d409e"
import script from "./ViewDashboards.vue?vue&type=script&lang=js"
export * from "./ViewDashboards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports